import type { ColorAPIResponse } from '~/types/shop'

export const isSpecial = (color: ColorAPIResponse): boolean => color.color.hex == null

export const sortSwatches = (colors: ColorAPIResponse[]): ColorAPIResponse[] => {
  const special = colors.filter(isSpecial)
  const notSpecial = colors.filter(color => !isSpecial(color))

  return [
    ...notSpecial.sort((a, b) =>
      (a.color.sortOrder || 0) - (b.color.sortOrder || 0)
    ),
    ...special.sort((a, b) =>
      (a.color.sortOrder || 0) - (b.color.sortOrder || 0)
    )
  ]
}
